module.exports = __webpack_public_path__ + "media/images/categories/headers/internet-and-technology-c5c315aeaa413e6db61b5973bcc70cc2.jpg";